import { FC } from 'react';
import { Link } from 'react-router-dom';

import { LogoWrapper, LogoText, LogoImage } from './styled';
import logoIcon from '../../assets/icons/favicon-96x96.png';

interface LogoProps {
  isDarkMode?: boolean;
  isHeader?: boolean;
}

export const Logo: FC<LogoProps> = ({ isHeader }) => {
  return (
    <LogoWrapper>
      <Link to='/' style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <LogoImage src={logoIcon} alt='AploCast Logo' $isHeader={isHeader} />
        <LogoText $isHeader={isHeader}>AploCast</LogoText>
      </Link>
    </LogoWrapper>
  );
};
